(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["identity-gifts-navigation"] && !Shopify.designMode) return;
  try {
    document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const menu = document.getElementById('IdentityGiftsMenu');
  if (!menu || !menu.open) return;
  menu.open = false;
  const summary = menu.querySelector('summary');
  summary.setAttribute('aria-expanded', 'false');
  summary.focus();
});
  } catch(e) { console.error(e); }
})();

})();
